import { render, staticRenderFns } from "./RelatorioPdf.vue?vue&type=template&id=a206638c&scoped=true"
import script from "./RelatorioPdf.vue?vue&type=script&lang=ts"
export * from "./RelatorioPdf.vue?vue&type=script&lang=ts"
import style0 from "./RelatorioPdf.vue?vue&type=style&index=0&id=a206638c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a206638c",
  null
  
)

export default component.exports